import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
    const [menuActive, setMenuActive] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // Function to check if a path is active
    const isActive = (path) => {
        return location.pathname === path || (path === '/' && location.pathname === '/');
    };

    const toggleMenu = () => {
        setMenuActive(!menuActive);
    };

    const handleNavigation = (path) => {
        navigate(path);
        setMenuActive(false);
    };

    return (
        <nav className="navbar sticky-nav" aria-label="Primary navigation">
            <div className="menu-icon" onClick={toggleMenu}>
                {menuActive ? (
                    <span>X</span>
                ) : (
                    <div>
                        <div></div>
                        <div></div>
                    </div>
                )}
            </div>
            <div className={`menu ${menuActive ? 'active' : ''}`}>
                <ul className={`nav-list ${menuActive ? 'active' : ''}`}>
                    <li className="nav-item">
                        <Link 
                            to="/" 
                            onClick={() => handleNavigation('/')}
                            className={isActive('/') ? 'active' : ''}
                        >
                            <span className="icon icon-home" aria-hidden="true"></span>
                            Home
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link
                            to="how-it-works"
                            onClick={() => handleNavigation('how-it-works')}
                            className={isActive('/how-it-works') ? 'active' : ''}
                        >
                            <span className="icon icon-how" aria-hidden="true"></span>
                            How It Works
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link
                            to="demos"
                            onClick={() => handleNavigation('demos')}
                            className={isActive('/demos') ? 'active' : ''}
                        >
                            <span className="icon icon-demos" aria-hidden="true"></span>
                            Demos
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link
                            to="NYX-Catalog"
                            onClick={() => handleNavigation('NYX-Catalog')}
                            className={isActive('/NYX-Catalog') ? 'active' : ''}
                        >
                            <span className="icon icon-hackathons" aria-hidden="true"></span>
                            NoCode Hackathons
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link
                            to="empower"
                            onClick={() => handleNavigation('empower')}
                            className={isActive('/empower') ? 'active' : ''}
                        >
                            <span className="emoji-icon" aria-hidden="true">💡</span>
                            Teacher Training
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link 
                            to="press" 
                            onClick={() => handleNavigation('press')}
                            className={isActive('/press') ? 'active' : ''}
                        >
                            <span className="icon icon-press" aria-hidden="true"></span>
                            Press
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link 
                            to="get-started" 
                            onClick={() => handleNavigation('get-started')}
                            className={isActive('/get-started') ? 'active' : ''}
                        >
                            <span className="icon icon-getstarted" aria-hidden="true"></span>
                            Get Started
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
